var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentComponent)?_c('div',{staticClass:"property-list"},[_c('h3',[_vm._v(_vm._s(_vm.$t('contrato_rastreabilidade.messages.main_list_title')))]),_c('el-card',[_c(_vm.currentComponent,{ref:"FarmListComponent",tag:"component",attrs:{"selected":_vm.selectedFarms},on:{"update:selected":function($event){_vm.selectedFarms=$event}}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }